<template>
	<button
		class="tab-button"
		:class="{
			gradient: active
		}"
	>
		<slot>{{ label }}</slot>
	</button>
</template>

<script setup>
defineProps({
	label: String,
	active: {
		type: Boolean,
		default: false
	}
});
</script>

<style scoped>
.tab-button {
	@apply rounded-full px-3 py-1 lg:px-6 lg:py-2 text-sm font-semibold transition-all duration-150 focus:outline-none  text-black border border-slate-200;
	white-space: nowrap;
}

.tab-button:hover {
	@apply bg-slate-50;
}

.tab-button.gradient {
	/* gradient */
	@apply text-white border-white;
	background: linear-gradient(90deg, #50b5ff 0%, #be55ff 99.95%);
}
</style>
